var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.hotel && _vm.isCheckIn
    ? _c("div", { staticClass: "item-hotel" }, [
        _c("ul", [
          _c("li", [
            _c(
              "div",
              {
                staticClass: "has-icon moon-icon d-flex justify-content-between"
              },
              [
                _c("div", [_c("p", [_vm._v(_vm._s(_vm.hotelName))])]),
                _vm._v(" "),
                _c("div", { staticClass: "tools" }, [
                  _c(
                    "button",
                    { staticClass: "btn info", on: { click: _vm.onClickInfo } },
                    [_c("div")]
                  )
                ])
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "info" }, [
              _c("p", { staticClass: "font-weight-normal" }, [
                _vm._v("check-in "),
                _c("b", [_vm._v(_vm._s(_vm.nights))]),
                _vm._v(" " + _vm._s(_vm.nights === 1 ? "Notte" : "Notti"))
              ])
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "add-transfer" })
          ])
        ])
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-a42d5a66", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a42d5a66","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/itinerario/ItemHotelCheckIn.vue
// module id = null
// module chunks = 